import {
  takeLatest, call, put, select,
} from 'redux-saga/effects';
import _ from 'lodash';
import axios from '../axiosConfig';
import { getTravelAgencySettingsSuccess, getTravelAgencySettingsRequest, getTravelAgencySettingsFailed } from '../../slices/user';
import { defaultAutocompleteSucess } from '../../slices/autocomplete';
import { ERROR_CODES } from '../../../constants';

const queryString = require('query-string');

function* getTravelAgencySettingsWorker({
  payload: {
    travelAgencyAliasName,
    isLoading,
  },
}) {
  try {
    const {
      travelAgency,
    } = yield select((store) => store.user);

    if (!travelAgency || !travelAgency?.isPageLoaded) {
      const requestData = {};
      let url = '/users/getTravelAgencySettings';
      if (travelAgencyAliasName) {
        requestData.travelAgencyAliasName = travelAgencyAliasName;
      }
      if (isLoading) {
        requestData.pageLoaded = false;
      }

      if (!_.isEmpty(requestData)) {
        url = `${url}?${queryString.stringify(requestData, { skipNull: true })}`;
      }

      let pageAccessPasswordCookie;
      try {
        pageAccessPasswordCookie = document.cookie && (document.cookie.split('; ').find((row) => row.startsWith('twpac=')) || '').replace('twpac=', '');
      } catch (e) { console.error(e); }

      const config = {
        method: 'GET',
        url,
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
          pac: pageAccessPasswordCookie,
        },
        withCredentials: true,
      };
      if (window && window.location.pathname && axios.defaults && axios.defaults.headers) {
        axios.defaults.headers['Referer-Path'] = window.location.pathname;
        axios.defaults.headers['Request-Origin'] = window.location.origin;
      }
      const { data } = yield call(axios, config);

      if (data && data.id) {
        yield put(getTravelAgencySettingsSuccess({ data }));
        if (data.defaultAutocompletes && data.defaultAutocompletes.length) {
          yield put(defaultAutocompleteSucess(data.defaultAutocompletes));
        }
      } else {
        yield put(getTravelAgencySettingsSuccess({}));
      }
    }
  } catch (error) {
    // Handle 401 Unauthorized
    if (error && error.response && error.response.status === 401) {
      document.cookie = `twpac=;expires=${new Date(1, 1, 1).toUTCString()};path=/`;
      window.location.reload();
      return;
    }

    // Handle AGENCY_MISMATCH specifically
    if (error && error.response && error.response.data
      && error.response.data.code === ERROR_CODES.AGENCY_MISMATCH) {
      yield put(getTravelAgencySettingsFailed(error.response.data));
      console.error(error);
      return;
    }

    // Default error handling
    let errorMessage = 'There is problem with your request. please try again.';
    if (error && error.response && error.response.data) {
      errorMessage = `${error.response.data.title} ${error.response.data.detail}`;
    } else if (error && typeof error === 'object' && error.message) {
      errorMessage = `${error.name}: ${error.message}`;
    }

    yield put(getTravelAgencySettingsFailed(errorMessage));
    console.error(error);
  }
}

function* getTravelAgencySettingsWatcher() {
  yield takeLatest(getTravelAgencySettingsRequest.toString(), getTravelAgencySettingsWorker);
}

export default getTravelAgencySettingsWatcher;
